import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SwitchListItem from '../../../../../list-items/SwitchListItem/SwitchListItem';

const LyricsBoldListItem = (props) => {
    const { lyricsBold, updateLyricsStyle } = props;
    const onBoldStyleChange = (event) => updateLyricsStyle({ bold: event.target.checked });
    
    return (
        <SwitchListItem
            text='Bold'
            checked={lyricsBold}
            onChange={onBoldStyleChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { bold: lyricsBold } = state.createPreview.present.videoSettings.lyrics.style;
    return { lyricsBold };
}

const mapDispatchToProps = (dispatch) => {
    const updateLyricsStyle = (properties) => dispatch(createActions.updateLyricsStyle(properties));
    return { updateLyricsStyle }
}

export default connect(mapStateToProps, mapDispatchToProps)(LyricsBoldListItem);